import React, { useState } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  FaHome,
  FaUser,
  FaCode,
  FaProjectDiagram,
  FaBlog,
  FaGraduationCap,
  FaEnvelope,
  FaSignOutAlt,
  FaBars,
  FaTimes,
} from "react-icons/fa";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const logoutUser = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      localStorage.clear();
      navigate("/admin");
    }
  };

  const navigationItems = [
    { to: "/admin-dashboard/home", label: "Home", icon: FaHome },
    { to: "/admin-dashboard/aboutme", label: "About Me", icon: FaUser },
    { to: "/admin-dashboard/skill", label: "Skills", icon: FaCode },
    {
      to: "/admin-dashboard/project",
      label: "Projects",
      icon: FaProjectDiagram,
    },
    { to: "/admin-dashboard/blog", label: "Blogs", icon: FaBlog },
    { to: "/admin-dashboard/edu", label: "Education", icon: FaGraduationCap },
    { to: "/admin-dashboard/msg", label: "Messages", icon: FaEnvelope },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <h1 className="text-2xl font-bold text-gray-900">
                  Portfolio Admin
                </h1>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="md:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100"
              >
                {isMobileMenuOpen ? (
                  <FaTimes size={20} />
                ) : (
                  <FaBars size={20} />
                )}
              </button>

              <button
                onClick={logoutUser}
                className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
              >
                <FaSignOutAlt className="mr-2" />
                Logout
              </button>
            </div>
          </div>
        </div>
      </header>

      <div className="flex">
        <div
          className={`${
            isMobileMenuOpen ? "block" : "hidden"
          } md:block md:w-64 bg-white shadow-sm border-r border-gray-200`}
        >
          <nav className="mt-5 px-2">
            <div className="space-y-1">
              {navigationItems.map((item) => (
                <NavItem
                  key={item.to}
                  to={item.to}
                  location={location}
                  icon={item.icon}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </NavItem>
              ))}
            </div>
          </nav>
        </div>

        <div className="flex-1">
          <main className="p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </div>
  );
};

const NavItem = ({ to, children, location, icon: Icon, onClick }) => {
  const isActive = location.pathname === to;
  return (
    <Link
      to={to}
      onClick={onClick}
      className={`group flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
        isActive
          ? "bg-indigo-100 text-indigo-700 border-r-2 border-indigo-500"
          : "text-gray-600 hover:bg-gray-50 hover:text-gray-900"
      }`}
    >
      <Icon
        className={`mr-3 flex-shrink-0 h-5 w-5 ${
          isActive
            ? "text-indigo-500"
            : "text-gray-400 group-hover:text-gray-500"
        }`}
      />
      {children}
    </Link>
  );
};

export default AdminDashboard;
